// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZjBx1","form":"Modal_form__APs+K"};